import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {PackagesRoutingModule} from "./packages-routing.module";
import {PackagesComponent} from "./packages.component";
import {SharedModule} from "../../shared/shared.module";
import {PackageDetailsBodyComponent} from "./package-details-body/package-details-body.component";
import {GsPackageDetailsComponent} from "./gs-package-details/gs-package-details.component";
import {LsPackageDetailsComponent} from "./ls-package-details/ls-package-details.component";
import {ZsPackageDetailsComponent} from "./zs-package-details/zs-package-details.component";
import {RsPackageDetailsComponent} from "./rs-package-details/rs-package-details.component";
import {VsPackageDetailsComponent} from "./vs-package-details/vs-package-details.component";
import {MsPackageDetailsComponent} from "./ms-package-details/ms-package-details.component";
import {CapitalizeFirstCharacterModule} from "../../shared/pipes/capitalizeFirstCharacter.module";
import {Ms2PackageDetailsComponent} from "./ms2-package-details/ms2-package-details.component";
import {EsPackageDetailsComponent} from "./es-package-details/es-package-details.component";

@NgModule({
  declarations: [
    PackagesComponent,
    PackageDetailsBodyComponent,
    GsPackageDetailsComponent,
    LsPackageDetailsComponent,
    ZsPackageDetailsComponent,
    RsPackageDetailsComponent,
    VsPackageDetailsComponent,
    MsPackageDetailsComponent,
    Ms2PackageDetailsComponent,
    EsPackageDetailsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PackagesRoutingModule,
    CapitalizeFirstCharacterModule
  ]
})
export class PackagesModule {
}
